'use strict';

angular.module('systemOwnerReviewControllers.ConfirmSystemOwnership')

.controller('ConfirmOwnershipBySystemTypeController', ['$scope', '$modal', '$state', 'confirmSystemOwnershipService', 'nextProcessStep', 'systemType', 'systemsToReview', function ($scope, $modal, $state, confirmSystemOwnershipService, nextProcessStep, systemType, systemsToReview) {

    $scope.systemType = systemType;
    $scope.isProcessing = false;

    // Compute groups by system owners list
    var partitionSystemsToReview = _.partition(systemsToReview, { SystemTypeID: systemType.SystemTypeID });
    var systemsToReviewForType = partitionSystemsToReview[0];
    var systemsToReviewNotInType = partitionSystemsToReview[1];

    $scope.systemsToReviewForType = systemsToReviewForType;

    var groups = _.groupBy($scope.systemsToReviewForType, function (system) {
        return _.chain(system.SystemOwners)
                .map('EmployeeID')
                .sortBy()
                .value();
    });

    $scope.withSystems = Object.keys(groups).length > 0;

    // Read only ?
    $scope.isReadOnly = !nextProcessStep.IsConfirmSystemOwnership;

    // Confirm review
    var firstSystemNotReviewed = _.chain(systemsToReviewNotInType)
                                  .filter({ IsReviewed: false })
                                  .first()
                                  .value();

    $scope.needCloseStepReview = function () {
        return _.findIndex(systemsToReviewNotInType, { IsReviewed: false }) === -1 && // All others systems are already reviewed
               _.findIndex(systemsToReviewForType, { IsReviewed: false }) !== -1; // These systems are not reviewed
    }

    $scope.confirmReview = function (systemsGroup) {
        $scope.isProcessing = true;

		if (systemsToReview.length === 0) {
			$state.go('systemOwnerReview.authUser.completed');
			return;
        }

        if (_.isUndefined(systemsToReviewForType) || _.isEmpty(systemsToReviewForType)) {
            $scope.goToSystemType(firstSystemNotReviewed);
            return;
        }
        
        var primarySystemOwner = systemsToReview[0].SystemOwners[0];
        
        confirmSystemOwnershipService.confirmReview($scope.authLogin, primarySystemOwner.EmployeeID, systemsToReviewForType)
        .then(function (needToContinueReview) {
            if (needToContinueReview === "false") {
                $state.go('systemOwnerReview.authUser.gettingStarted', {
                    authLogin: $scope.authLogin
                }, { reload: true });
            }
            else if (!_.isUndefined(firstSystemNotReviewed)) {
                $scope.goToSystemType(firstSystemNotReviewed);
            }
        });
    }

    $scope.goToSystemType = function (systemType) {
        $state.go('systemOwnerReview.authUser.confirmSystemOwnership.bySystemType', {
            authLogin: $scope.authLogin,
            systemTypeSlug: systemType.SystemTypeSlug
        }, {
            reload: true
        })
    }
}]);
